export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-map-960-5420eeb0ff62db9ca3871f9669c73de4.webp";